import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { Box } from "@mui/material";
export default function PkCommonArrow(props) {
  const { color } = props;
  return (
    <Box sx={{ position: "absolute", width: "100%" }}>
      {props.upward ? (
        <ArrowDropUp
          sx={{
            color: color,
            fontSize: "10rem",
            position: "relative",
            left: "calc(50% - 80px)",
            top: `-90px`,
          }}
        />
      ) : (
        <ArrowDropDown
          sx={{
            color: color,
            fontSize: "10rem",
            position: "relative",
            left: "calc(50% - 80px)",
            top: `-70px`,
          }}
        />
      )}
    </Box>
  );
}
